export const MAINTENANCE_BYPASS_STORAGE_KEY = 'rtt_maintenance_bypass';

export const MAINTENANCE_BYPASS_VALUE = 'admin_handoff';

export function isMaintenanceBypassActive(): boolean {
  try {
    return localStorage.getItem(MAINTENANCE_BYPASS_STORAGE_KEY) === MAINTENANCE_BYPASS_VALUE;
  } catch {
    return false;
  }
}

export function setMaintenanceBypassFromAdminHandoff(): void {
  try {
    localStorage.setItem(MAINTENANCE_BYPASS_STORAGE_KEY, MAINTENANCE_BYPASS_VALUE);
  } catch {
    /* ignore */
  }
}

export function clearMaintenanceBypass(): void {
  try {
    localStorage.removeItem(MAINTENANCE_BYPASS_STORAGE_KEY);
  } catch {
    /* ignore */
  }
}
